<template>
  <EventListener
    :events="[
      'delivery_location_updated',
      'failed_to_update_delivery_location',
      'delivery_location_update_requested',
    ]"
    @delivery_location_updated="onDeliveryLocationUpdated"
    @failed_to_update_delivery_location="onDeliveryLocationUpdateFailed"
    @delivery_location_update_requested="editDeiveryLocation"
  />
</template>

<script>
import { defineComponent } from 'vue'
import EventListener from '../utils/EventListener.vue'

export default defineComponent({
  name: 'DeliveryLocationUpdater',
  components: { EventListener },
  data() {
    return {}
  },
  mounted() {},

  methods: {
    async editDeiveryLocation(deliveryLocation) {
      const prompt = await this.$Events.sendDataRequestResolve(
        'customPrompt',
        {
          title: `Cout de livraison sur ${deliveryLocation.countryName}, ${deliveryLocation.city}`,
          subTitle: 'Changez le cout de livraison',
          formFields: [
            {
              type: 'number',
              propertyName: 'deliveryCost',
              label: 'Cout de livraison',
              defaultValue: deliveryLocation.deliveryCost,
              inputProps: {},
              required: true,
            },
            {
              type: 'select',
              propertyName: 'currency',
              label: 'Devise',
              options: ['XOF', 'NGN', 'USD', 'EUR'],
              defaultValue: deliveryLocation.currency,
              required: true,
            },
          ],
          successText: 'Sauvegarder',
        },
        9999999999,
      )
      if (!prompt.accepted) return null
      const data = {
        ...deliveryLocation,
        deliveryCost: prompt.data.deliveryCost,
        currency: prompt.data.currency,
      }

      this.$Events.dispatchEvent('delivery_location_ready_to_be_updated', data)
      this.$Events.dispatchEvent('start_loading')
    },
    onDeliveryLocationUpdated() {
      this.$Events.dispatchEvent('finish_loading')
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Couts de livraison sauvegardé',
        body: 'Le nouveau cout de livraison a été sauvegardé avec succès',
      })
      this.$router.back()
    },
    onDeliveryLocationUpdateFailed() {
      this.$Events.dispatchEvent('finish_loading')
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Echec de sauvegarde',
        body: 'Erreur de mise à jour du nouveau cout, veuillez réessayer',
      })
    },
  },
})
</script>

<style scoped></style>
